import React from 'react'
import BaseHeading from './BaseHeading'

interface PropsType {
  children: React.ReactNode
}

const MiscHeading = (props: PropsType) => <BaseHeading $borderColor="#ccc">{props.children}</BaseHeading>

export default MiscHeading
